import {
  IncidentsSupport,
  PerformanceCategoriesSupport,
  QuestionSupport,
  RecurrenceBaseDateType
} from '@app/shared/enums';
import { FormsSupport } from '@app/shared/enums/forms-support.enum';
import { PeFormWorkflowStepApiModel } from './PeFormWorkflowStepApiModel';
import { PeFormQuestionBaseApiModel } from './PeFormQuestionBaseApiModel';
import { AclItemApiModel } from '../../AclItemApiModel';

export class PeFormApiModel {
  public Id: number;
  public Name: string;
  public Description: string;
  public WhatIsSubject: Array<AclItemApiModel>;
  public HideFromSupervisors: boolean;
  public IsActive: boolean;
  public IsMandatory: boolean;
  public HasInstanceNumber: boolean;
  public HasCreatorNarrative: boolean;
  public HasSubjectNarrative: boolean;
  public IncidentsSupport: IncidentsSupport;
  public PerformanceCategoriesSupport: PerformanceCategoriesSupport;
  public QuestionSupport: QuestionSupport;
  public FormsSupport: FormsSupport;
  public HasFormsSupportingDocuments: boolean;
  public HasSummarySupportingDocuments: boolean;
  public HasSnapshot: boolean;
  public HasAboutAndInterests: boolean;
  public HasGoals: boolean;
  public HasCitizenFeedback: boolean;
  public HasTrainingCourseClasses: boolean;
  public DisplayRelatedPerformanceData: boolean;
  public DisplayHistoryToSubject: boolean;
  public DisplayCategoryAverage: boolean;
  public WorkflowSteps: Array<PeFormWorkflowStepApiModel>;
  public Questions: Array<PeFormQuestionBaseApiModel>;
  public RecurrenceDue: number;
  public RecurrenceInterval: number;
  public RecurrenceIntervalDirection: number;
  public RecurrenceBaseDateType: RecurrenceBaseDateType;
  public RecurrenceBaseDate: Date;
  public AllowHeaderEdits: boolean;

  // PIP (Performance Improvement Plan) component settings
  public PipImprovementPlanEnabled: boolean;
  public PipImprovementPlanReasonForImprovementPlan: boolean;
  public PipImprovementPlanReasonNarrative: boolean;
  public PipImprovementPlanPossibleConsequences: boolean;
  public PipImprovementPlanConsequencesNarrative: boolean;
  public PipImprovementActivitiesEnabled: boolean;
  public PipImprovementActivitiesAllowComments: boolean;
  public PipImprovementActivitiesRequireComments: boolean;
  public PipImprovementFormsEnabled: boolean;
  public PipScheduleEnabled: boolean;

  public deserialize(data: object): PeFormApiModel {
    Object.assign(this, data);

    this.WhatIsSubject = this.WhatIsSubject?.map((x) => new AclItemApiModel().deserialize(x));
    this.WorkflowSteps = this.WorkflowSteps?.map((x) => new PeFormWorkflowStepApiModel().deserialize(x));

    return this;
  }
}
